import { useState } from "react";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { INPUT_LABEL_STYLE, INPUT_STYLE } from "../assets/constants";
import Form from "./admin/Form";

export default function SignupComponent() {
    const [studentId, setStudentId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [address, setAddress] = useState(null);
    const [contact, setContact] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [disable, setDisable] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        nameError: null,
        userNameError: null,
        emailError: null,
        studentIdError: null,
        contactError: null,
        addressError: null,
        passwordError: null,
        birthDateError: null,
        idError: null,
    });

    const handleSubmit = async () => {

        // validateFileds()
        const body = {
            studentId: studentId,
            name: name,
            userName: userName,
            contact: contact,
            password: password,
            email: email,
            address: address,
            birthDate: birthDate,

        };
        console.log(body);

    };

    function validateFileds() {
        let error = false
        if (!name) {
            setErrorMessage((prevState) => ({
                ...prevState,
                nameError: 'Please enter student Name',
            }));
            error = true;
        } else if (name?.legth < 5) {
            setErrorMessage((prevState) => ({
                ...prevState,
                nameError: 'Student Name must be at least 5 characters long',
            }));
            error = true;
        }
        if (!userName) {
            setErrorMessage((prevState) => ({
                ...prevState,
                userNameError: 'Please enter student userName',
            }));
            error = true;
        } else if (userName?.legth < 6) {
            setErrorMessage((prevState) => ({
                ...prevState,
                userNameError: 'Username must be at least 6 characters long',
            }));
            error = true;
        }
        if (!email) {
            setErrorMessage((prevState) => ({
                ...prevState,
                emailError: 'Please enter email',
            }));
            error = true;
        }
        if (!password) {
            setErrorMessage((prevState) => ({
                ...prevState,
                passwordError: "Please enter password",
            }));
            error = true;
        } else if (password?.legth < 8) {
            setErrorMessage((prevState) => ({
                ...prevState,
                passwordError: "Password must be at least 8 characters long",
            }));
            error = true;
        }
        if (!contact) {
            setErrorMessage((prevState) => ({
                ...prevState,
                contactError: 'Please enter contact Number',
            }));
            error = true;
        }
        if (!address) {
            setErrorMessage((prevState) => ({
                ...prevState,
                addressError: 'Please enter student address',
            }));
            error = true;
        }
        return error
    }
    return (
        <>
            <div className="bg-white relative ">
                <div className="flex flex-col items-center justify-between pt-0 pr-10 pb-0 pl-10 mt-0 mr-auto mb-0 ml-auto max-w-7xl xl:px-5 lg:flex-row">
                    <div className="flex flex-col items-center w-full pt-5 pr-10 pb-20 pl-10 lg:pt-20 lg:flex-row">
                        <div className="w-full bg-cover hidden lg:block relative max-w-md lg:max-w-xl lg:w-7/12">
                            <div className="flex flex-col items-center justify-center w-full h-full relative lg:pr-10">
                                <img src="https://res.cloudinary.com/macxenon/image/upload/v1631570592/Run_-_Health_qcghbu.png" className="btn-" />
                            </div>
                        </div>
                        <div className="w-full mt-12 mr-0 mb-0 ml-0 relative z-10 max-w-3xl lg:mt-0 lg:w-1/2">
                            {/* form area */}
                            <div className="flex flex-col items-start justify-start w-full p-10 bg-white shadow-2xl rounded-xl relative z-10">
                                <p className="w-full text-4xl font-medium text-center leading-snug font-serif">Signup an account</p>
                                <div className="w-full mt-6 mr-0 mb-0 ml-0 relative space-y-8">

                                    <div className="space-y-10 select-none">
                                        {/* name and username */}
                                        <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                                            {/* name */}
                                            <div className="">
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        id="floating_outlined"
                                                        className={`${INPUT_STYLE} ${errorMessage.nameError && "border-red-600 text-red-600"}`}
                                                        placeholder=" "
                                                        value={name}
                                                        disabled={disable}
                                                        onChange={(e) => setName(e.target.value)}
                                                        onBlur={() => {
                                                            !name && setErrorMessage(prev => ({
                                                                ...prev,
                                                                nameError: "Name is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.nameError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                nameError: null
                                                            }))
                                                        }}

                                                    />
                                                    <label
                                                        htmlFor="floating_outlined"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.nameError && "text-red-600"}`}

                                                    >
                                                        Name
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.nameError}</p>
                                            </div>

                                            {/* username */}
                                            <div>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        name="userName"
                                                        id="floating_userName"
                                                        placeholder=" "
                                                        value={userName}
                                                        disabled={disable}
                                                        className={`${INPUT_STYLE} ${errorMessage.userNameError && "border-red-600 text-red-600"}`}
                                                        onChange={(e) => setUserName(e.target.value)}
                                                        onBlur={() => {
                                                            !userName && setErrorMessage(prev => ({
                                                                ...prev,
                                                                userNameError: "User Name is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.userNameError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                userNameError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_userName"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.userNameError && "text-red-600"}`}
                                                    >
                                                        User Name
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.userNameError}</p>

                                            </div>
                                        </div>

                                        {/* email and password */}
                                        <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                                            {/* email */}
                                            <div>
                                                <div className="relative">
                                                    <input
                                                        type="email"
                                                        id="floating_email"
                                                        value={email}
                                                        placeholder=" "
                                                        disabled={disable}
                                                        className={`${INPUT_STYLE} ${errorMessage.emailError && "border-red-600 text-red-600"}`}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        onBlur={() => {
                                                            !email && setErrorMessage(prev => ({
                                                                ...prev,
                                                                emailError: "Email is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.emailError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                userNameError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_userName"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.emailError && "text-red-600"}`}
                                                    >
                                                        Email
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.emailError}</p>

                                            </div>

                                            {/* password */}
                                            <div>

                                                <div className="relative">
                                                    <input
                                                        type={showPassword ? 'text' : 'password'}
                                                        id="floating_password"
                                                        placeholder=" "
                                                        disabled={disable}
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)} className={`${INPUT_STYLE} ${errorMessage.passwordError && "border-red-600 text-red-600"}`}
                                                        onBlur={() => {
                                                            !password && setErrorMessage(prev => ({
                                                                ...prev,
                                                                passwordError: "Password is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.passwordError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                passwordError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_password"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.passwordError && "text-red-600"}`}

                                                    >
                                                        Password
                                                    </label>
                                                    {showPassword ? <BsFillEyeSlashFill onClick={() => setShowPassword(false)} className={`absolute top-5 cursor-pointer right-4 w-6 h-5 ${errorMessage.passwordError && "text-red-600"} `} />
                                                        : <BsFillEyeFill onClick={() => setShowPassword(true)} className={`absolute top-5 right-4 w-6 h-5 cursor-pointer ${errorMessage.passwordError && "text-red-600"}`} />
                                                    }
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.passwordError}</p>

                                            </div>
                                        </div>

                                        {/* phone and address */}

                                        <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                                            {/* contact */}
                                            <div>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        id="floating_contact"
                                                        placeholder=" "
                                                        value={contact}
                                                        disabled={disable}
                                                        className={`${INPUT_STYLE} ${errorMessage.contactError && "border-red-600 text-red-600"}`}
                                                        onChange={(e) => setContact(e.target.value)}
                                                        onBlur={() => {
                                                            !contact && setErrorMessage(prev => ({
                                                                ...prev,
                                                                contactError: "Contact is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.contactError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                contactError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_contact"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.contactError && "text-red-600"}`}
                                                    >
                                                        Contact
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.contactError}</p>

                                            </div>
                                            {/* address */}
                                            <div>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        id="floating_address"
                                                        placeholder=" "
                                                        value={address}
                                                        disabled={disable}
                                                        className={`${INPUT_STYLE} ${errorMessage.addressError && "border-red-600 text-red-600"}`}
                                                        onChange={(e) => setAddress(e.target.value)}
                                                        onBlur={() => {
                                                            !address && setErrorMessage(prev => ({
                                                                ...prev,
                                                                addressError: "Address is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.addressError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                addressError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_address"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.addressError && "text-red-600"}`}
                                                    >
                                                        Address
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.addressError}</p>

                                            </div>
                                        </div>



                                        <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                                            {/* contact */}
                                            <div>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        id="floating_student_id"
                                                        placeholder=" "
                                                        value={studentId}
                                                        disabled={disable}
                                                        className={`${INPUT_STYLE} ${errorMessage.studentIdError && "border-red-600 text-red-600"}`}
                                                        onChange={(e) => setStudentId(e.target.value)}
                                                        onBlur={() => {
                                                            !studentId && setErrorMessage(prev => ({
                                                                ...prev,
                                                                studentIdError: "Student id is required"
                                                            }))
                                                        }}
                                                        onClick={() => {
                                                            errorMessage.studentIdError && setErrorMessage(prev => ({
                                                                ...prev,
                                                                studentIdError: null
                                                            }))
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="floating_student_id"
                                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.studentIdError && "text-red-600"}`}
                                                    >
                                                        Student Id
                                                    </label>
                                                </div>
                                                <p className="text-sm text-red-600 h-4">{errorMessage.contactError}</p>

                                            </div>
                                            {/* address */}
                                            <div>
                                                {/* date of bith */}
                                                <div className="relative">
                                                    <input
                                                        type="date"
                                                        id="floating_birthDate"
                                                        className={INPUT_STYLE}
                                                        placeholder=" "
                                                        value={birthDate}
                                                        disabled={disable}
                                                        onChange={(e) => setBirthDate(e.target.value)}
                                                    />
                                                    <label
                                                        htmlFor="floating_birthDate"
                                                        className={INPUT_LABEL_STYLE}
                                                    >
                                                        Date of Birth
                                                    </label>
                                                </div>
                                                {/* <p className="text-sm text-red-600 h-4">{errorMessage.addressError}</p> */}

                                            </div>
                                        </div>

                                    </div>
                                    <div className="relative">
                                        <button className="w-full inline-block pt-4 pr-5 pb-4 pl-5 text-xl font-medium text-center text-white bg-indigo-500
                  rounded-lg transition duration-200 hover:cursor-pointer hover:bg-indigo-600 ease"
                                            onClick={handleSubmit}
                                        >
                                            Signup
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* SVG designs */}
                            <svg viewbox="0 0 91 91" className="absolute top-0 left-0 z-0 w-32 h-32 -mt-12 -ml-12 text-yellow-300
            fill-current"><g stroke="none" strokewidth="1" fillrule="evenodd"><g fillrule="nonzero"><g><g><circle
                                    cx="3.261" cy="3.445" r="2.72" /><circle cx="15.296" cy="3.445" r="2.719" /><circle cx="27.333" cy="3.445"
                                        r="2.72" /><circle cx="39.369" cy="3.445" r="2.72" /><circle cx="51.405" cy="3.445" r="2.72" /><circle cx="63.441"
                                            cy="3.445" r="2.72" /><circle cx="75.479" cy="3.445" r="2.72" /><circle cx="87.514" cy="3.445" r="2.719" /></g><g
                                                transform="translate(0 12)"><circle cx="3.261" cy="3.525" r="2.72" /><circle cx="15.296" cy="3.525"
                                                    r="2.719" /><circle cx="27.333" cy="3.525" r="2.72" /><circle cx="39.369" cy="3.525" r="2.72" /><circle
                                            cx="51.405" cy="3.525" r="2.72" /><circle cx="63.441" cy="3.525" r="2.72" /><circle cx="75.479" cy="3.525"
                                                r="2.72" /><circle cx="87.514" cy="3.525" r="2.719" /></g><g transform="translate(0 24)"><circle cx="3.261"
                                                    cy="3.605" r="2.72" /><circle cx="15.296" cy="3.605" r="2.719" /><circle cx="27.333" cy="3.605" r="2.72" /><circle
                                            cx="39.369" cy="3.605" r="2.72" /><circle cx="51.405" cy="3.605" r="2.72" /><circle cx="63.441" cy="3.605"
                                                r="2.72" /><circle cx="75.479" cy="3.605" r="2.72" /><circle cx="87.514" cy="3.605" r="2.719" /></g><g
                                                    transform="translate(0 36)"><circle cx="3.261" cy="3.686" r="2.72" /><circle cx="15.296" cy="3.686"
                                                        r="2.719" /><circle cx="27.333" cy="3.686" r="2.72" /><circle cx="39.369" cy="3.686" r="2.72" /><circle
                                            cx="51.405" cy="3.686" r="2.72" /><circle cx="63.441" cy="3.686" r="2.72" /><circle cx="75.479" cy="3.686"
                                                r="2.72" /><circle cx="87.514" cy="3.686" r="2.719" /></g><g transform="translate(0 49)"><circle cx="3.261"
                                                    cy="2.767" r="2.72" /><circle cx="15.296" cy="2.767" r="2.719" /><circle cx="27.333" cy="2.767" r="2.72" /><circle
                                            cx="39.369" cy="2.767" r="2.72" /><circle cx="51.405" cy="2.767" r="2.72" /><circle cx="63.441" cy="2.767"
                                                r="2.72" /><circle cx="75.479" cy="2.767" r="2.72" /><circle cx="87.514" cy="2.767" r="2.719" /></g><g
                                                    transform="translate(0 61)"><circle cx="3.261" cy="2.846" r="2.72" /><circle cx="15.296" cy="2.846"
                                                        r="2.719" /><circle cx="27.333" cy="2.846" r="2.72" /><circle cx="39.369" cy="2.846" r="2.72" /><circle
                                            cx="51.405" cy="2.846" r="2.72" /><circle cx="63.441" cy="2.846" r="2.72" /><circle cx="75.479" cy="2.846"
                                                r="2.72" /><circle cx="87.514" cy="2.846" r="2.719" /></g><g transform="translate(0 73)"><circle cx="3.261"
                                                    cy="2.926" r="2.72" /><circle cx="15.296" cy="2.926" r="2.719" /><circle cx="27.333" cy="2.926" r="2.72" /><circle
                                            cx="39.369" cy="2.926" r="2.72" /><circle cx="51.405" cy="2.926" r="2.72" /><circle cx="63.441" cy="2.926"
                                                r="2.72" /><circle cx="75.479" cy="2.926" r="2.72" /><circle cx="87.514" cy="2.926" r="2.719" /></g><g
                                                    transform="translate(0 85)"><circle cx="3.261" cy="3.006" r="2.72" /><circle cx="15.296" cy="3.006"
                                                        r="2.719" /><circle cx="27.333" cy="3.006" r="2.72" /><circle cx="39.369" cy="3.006" r="2.72" /><circle
                                            cx="51.405" cy="3.006" r="2.72" /><circle cx="63.441" cy="3.006" r="2.72" /><circle cx="75.479" cy="3.006"
                                                r="2.72" /><circle cx="87.514" cy="3.006" r="2.719" /></g></g></g></g></svg>
                            <svg viewbox="0 0 91 91" className="absolute bottom-0 right-0 z-0 w-32 h-32 -mb-12 -mr-12 text-indigo-500
            fill-current"><g stroke="none" strokewidth="1" fillrule="evenodd"><g fillrule="nonzero"><g><g><circle
                                    cx="3.261" cy="3.445" r="2.72" /><circle cx="15.296" cy="3.445" r="2.719" /><circle cx="27.333" cy="3.445"
                                        r="2.72" /><circle cx="39.369" cy="3.445" r="2.72" /><circle cx="51.405" cy="3.445" r="2.72" /><circle cx="63.441"
                                            cy="3.445" r="2.72" /><circle cx="75.479" cy="3.445" r="2.72" /><circle cx="87.514" cy="3.445" r="2.719" /></g><g
                                                transform="translate(0 12)"><circle cx="3.261" cy="3.525" r="2.72" /><circle cx="15.296" cy="3.525"
                                                    r="2.719" /><circle cx="27.333" cy="3.525" r="2.72" /><circle cx="39.369" cy="3.525" r="2.72" /><circle
                                            cx="51.405" cy="3.525" r="2.72" /><circle cx="63.441" cy="3.525" r="2.72" /><circle cx="75.479" cy="3.525"
                                                r="2.72" /><circle cx="87.514" cy="3.525" r="2.719" /></g><g transform="translate(0 24)"><circle cx="3.261"
                                                    cy="3.605" r="2.72" /><circle cx="15.296" cy="3.605" r="2.719" /><circle cx="27.333" cy="3.605" r="2.72" /><circle
                                            cx="39.369" cy="3.605" r="2.72" /><circle cx="51.405" cy="3.605" r="2.72" /><circle cx="63.441" cy="3.605"
                                                r="2.72" /><circle cx="75.479" cy="3.605" r="2.72" /><circle cx="87.514" cy="3.605" r="2.719" /></g><g
                                                    transform="translate(0 36)"><circle cx="3.261" cy="3.686" r="2.72" /><circle cx="15.296" cy="3.686"
                                                        r="2.719" /><circle cx="27.333" cy="3.686" r="2.72" /><circle cx="39.369" cy="3.686" r="2.72" /><circle
                                            cx="51.405" cy="3.686" r="2.72" /><circle cx="63.441" cy="3.686" r="2.72" /><circle cx="75.479" cy="3.686"
                                                r="2.72" /><circle cx="87.514" cy="3.686" r="2.719" /></g><g transform="translate(0 49)"><circle cx="3.261"
                                                    cy="2.767" r="2.72" /><circle cx="15.296" cy="2.767" r="2.719" /><circle cx="27.333" cy="2.767" r="2.72" /><circle
                                            cx="39.369" cy="2.767" r="2.72" /><circle cx="51.405" cy="2.767" r="2.72" /><circle cx="63.441" cy="2.767"
                                                r="2.72" /><circle cx="75.479" cy="2.767" r="2.72" /><circle cx="87.514" cy="2.767" r="2.719" /></g><g
                                                    transform="translate(0 61)"><circle cx="3.261" cy="2.846" r="2.72" /><circle cx="15.296" cy="2.846"
                                                        r="2.719" /><circle cx="27.333" cy="2.846" r="2.72" /><circle cx="39.369" cy="2.846" r="2.72" /><circle
                                            cx="51.405" cy="2.846" r="2.72" /><circle cx="63.441" cy="2.846" r="2.72" /><circle cx="75.479" cy="2.846"
                                                r="2.72" /><circle cx="87.514" cy="2.846" r="2.719" /></g><g transform="translate(0 73)"><circle cx="3.261"
                                                    cy="2.926" r="2.72" /><circle cx="15.296" cy="2.926" r="2.719" /><circle cx="27.333" cy="2.926" r="2.72" /><circle
                                            cx="39.369" cy="2.926" r="2.72" /><circle cx="51.405" cy="2.926" r="2.72" /><circle cx="63.441" cy="2.926"
                                                r="2.72" /><circle cx="75.479" cy="2.926" r="2.72" /><circle cx="87.514" cy="2.926" r="2.719" /></g><g
                                                    transform="translate(0 85)"><circle cx="3.261" cy="3.006" r="2.72" /><circle cx="15.296" cy="3.006"
                                                        r="2.719" /><circle cx="27.333" cy="3.006" r="2.72" /><circle cx="39.369" cy="3.006" r="2.72" /><circle
                                            cx="51.405" cy="3.006" r="2.72" /><circle cx="63.441" cy="3.006" r="2.72" /><circle cx="75.479" cy="3.006"
                                                r="2.72" /><circle cx="87.514" cy="3.006" r="2.719" /></g></g></g></g></svg>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}